import Get from './Get';

export default class Delete extends Get {
    method = 'DELETE';
}
